// extracted by mini-css-extract-plugin
module.exports = {"root":"Matching_root__2n95Z","left":"Matching_left__24Cvi","right":"Matching_right__3d1j8"};